import { render } from "./AssetStatus.vue?vue&type=template&id=5b984ef2&scoped=true"
import script from "./AssetStatus.vue?vue&type=script&lang=js"
export * from "./AssetStatus.vue?vue&type=script&lang=js"

import "./AssetStatus.vue?vue&type=style&index=0&id=5b984ef2&scoped=true&lang=css"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b984ef2"]])

export default __exports__